export async function getApiErrorMessage(error, fallback = 'Request failed') {
  const data = error?.response?.data;
  if (!data) return error?.message || fallback;
  if (typeof data === 'string') return data;
  if (typeof data.error === 'string') return data.error;
  if (typeof Blob !== 'undefined' && data instanceof Blob) {
    try {
      const text = await data.text();
      if (!text) return fallback;
      try {
        const parsed = JSON.parse(text);
        return parsed.error || text;
      } catch {
        return text;
      }
    } catch {
      return fallback;
    }
  }
  return fallback;
}
